var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxUnchecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#171C1E",
  d: "M4 .5h12A3.5 3.5 0 0 1 19.5 4v12a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 16V4A3.5 3.5 0 0 1 4 .5Z",
  opacity: 0.2
})));
export { SvgCheckboxUnchecked as ReactComponent };